(function() {
  'use strict';

  var routesRoot = window.Shopify && window.Shopify.routes
    ? window.Shopify.routes.root
    : '/';

  function message(key, fallback) {
    return document.body.dataset[key] || fallback;
  }

  function showNotification(text, isError) {
    var previous = document.querySelector('[data-theme-notification]');
    if (previous) previous.remove();

    var notification = document.createElement('div');
    notification.className = 'theme-notification' + (isError ? ' is-error' : '');
    notification.dataset.themeNotification = '';
    notification.setAttribute('role', isError ? 'alert' : 'status');
    notification.setAttribute('aria-live', isError ? 'assertive' : 'polite');
    notification.textContent = text;
    document.body.appendChild(notification);

    window.requestAnimationFrame(function() {
      notification.classList.add('is-visible');
    });

    window.setTimeout(function() {
      notification.classList.remove('is-visible');
      window.setTimeout(function() {
        notification.remove();
      }, 250);
    }, 2800);
  }

  function updateCartCount() {
    return fetch(routesRoot + 'cart.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function(response) {
        if (!response.ok) throw new Error('Cart request failed');
        return response.json();
      })
      .then(function(cart) {
        document.querySelectorAll('[data-cart-link], .cart-link').forEach(function(link) {
          var count = link.querySelector('.cart-count');

          if (!count && cart.item_count > 0) {
            count = document.createElement('span');
            count.className = 'cart-count';
            link.appendChild(count);
          }

          if (count) {
            count.textContent = cart.item_count;
            count.hidden = cart.item_count === 0;
          }
        });
      });
  }

  function addVariant(button) {
    if (button.disabled || button.classList.contains('sold-out-btn')) {
      showNotification(message('cartSoldOut', 'Produto esgotado.'), true);
      return;
    }

    var variantId = button.dataset.variantId || button.dataset.productId;
    if (!variantId) return;

    button.disabled = true;
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');

    fetch(routesRoot + 'cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    })
      .then(function(response) {
        if (!response.ok) {
          return response.json().catch(function() { return {}; }).then(function(data) {
            var error = new Error('Add to cart failed');
            error.data = data;
            throw error;
          });
        }
        return response.json();
      })
      .then(function() {
        return updateCartCount();
      })
      .then(function() {
        showNotification(message('cartAddSuccess', 'Produto adicionado ao carrinho.'), false);
      })
      .catch(function(error) {
        var description = error.data && (error.data.description || error.data.message);
        showNotification(description || message('cartAddError', 'Nao foi possivel adicionar o produto.'), true);
      })
      .finally(function() {
        button.disabled = false;
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
      });
  }

  document.addEventListener('click', function(event) {
    var button = event.target.closest('.add-cart-btn');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();
    addVariant(button);
  });
})();

(function() {
  'use strict';

  var deferredInstallPrompt = null;

  function isInstalled() {
    return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
  }

  function isIos() {
    return /iphone|ipad|ipod/i.test(window.navigator.userAgent) ||
      (window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1);
  }

  function installWidgets() {
    return document.querySelectorAll('[data-pwa-install]');
  }

  function installPromos() {
    return document.querySelectorAll('[data-pwa-install-promo]');
  }

  function showWidgets() {
    if (isInstalled()) {
      hideWidgets();
      return;
    }

    installPromos().forEach(function(promo) {
      promo.hidden = false;
    });

    installWidgets().forEach(function(widget) {
      widget.hidden = false;

      var dialog = widget.querySelector('[data-pwa-install-dialog]');
      if (dialog && !dialog.dataset.pwaCloseBound) {
        dialog.dataset.pwaCloseBound = 'true';
        dialog.addEventListener('close', function() {
          document.documentElement.classList.remove('pwa-dialog-open');
        });
      }
    });
  }

  function hideWidgets() {
    installPromos().forEach(function(promo) {
      promo.hidden = true;
    });

    installWidgets().forEach(function(widget) {
      closeDialog(widget.querySelector('[data-pwa-install-dialog]'));
      widget.hidden = true;
    });
  }

  function showInstructions(widget, messageText) {
    var status = widget.querySelector('[data-pwa-install-status]');
    if (!status) return;
    status.textContent = messageText;
    status.hidden = false;
  }

  function configureDialog(widget) {
    var dialog = widget.querySelector('[data-pwa-install-dialog]');
    if (!dialog) return;

    var confirmButton = dialog.querySelector('[data-pwa-install-confirm]');
    var guidance = dialog.querySelector('[data-pwa-install-guidance]');
    var guidanceTitle = dialog.querySelector('[data-pwa-guidance-title]');
    var guidanceText = dialog.querySelector('[data-pwa-guidance-text]');
    var canInstallDirectly = Boolean(deferredInstallPrompt);

    if (confirmButton) confirmButton.hidden = !canInstallDirectly;
    if (guidance) guidance.hidden = canInstallDirectly;

    if (!canInstallDirectly && guidanceTitle && guidanceText) {
      if (isIos()) {
        guidanceTitle.textContent = widget.dataset.iosTitle;
        guidanceText.textContent = widget.dataset.iosInstructions;
      } else {
        guidanceTitle.textContent = widget.dataset.browserTitle;
        guidanceText.textContent = widget.dataset.browserInstructions;
      }
    }
  }

  function openDialog(widget) {
    var dialog = widget.querySelector('[data-pwa-install-dialog]');
    if (!dialog) return;

    configureDialog(widget);
    document.documentElement.classList.add('pwa-dialog-open');

    if (typeof dialog.showModal === 'function') {
      if (!dialog.open) dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }

    window.requestAnimationFrame(function() {
      var preferredFocus = dialog.querySelector('[data-pwa-install-confirm]:not([hidden])') ||
        dialog.querySelector('[data-pwa-dialog-close]');
      if (preferredFocus) preferredFocus.focus();
    });
  }

  function closeDialog(dialog) {
    if (!dialog) return;

    if (typeof dialog.close === 'function' && dialog.open) {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
      document.documentElement.classList.remove('pwa-dialog-open');
    }
  }

  window.addEventListener('beforeinstallprompt', function(event) {
    event.preventDefault();
    deferredInstallPrompt = event;
    showWidgets();

    installWidgets().forEach(function(widget) {
      var dialog = widget.querySelector('[data-pwa-install-dialog]');
      if (dialog && dialog.open) configureDialog(widget);
    });
  });

  window.addEventListener('appinstalled', function() {
    deferredInstallPrompt = null;
    hideWidgets();
  });

  document.addEventListener('click', function(event) {
    var button = event.target.closest('[data-pwa-install-button], [data-pwa-install-trigger]');
    if (button) {
      var buttonWidget = button.closest('[data-pwa-install]');
      if (!buttonWidget) buttonWidget = installWidgets()[0];
      if (buttonWidget) openDialog(buttonWidget);
      return;
    }

    var closeButton = event.target.closest('[data-pwa-dialog-close]');
    if (closeButton) {
      closeDialog(closeButton.closest('[data-pwa-install-dialog]'));
      return;
    }

    var confirmButton = event.target.closest('[data-pwa-install-confirm]');
    if (confirmButton) {
      var confirmWidget = confirmButton.closest('[data-pwa-install]');
      if (!confirmWidget || !deferredInstallPrompt) {
        if (confirmWidget) configureDialog(confirmWidget);
        return;
      }

      var installPrompt = deferredInstallPrompt;
      deferredInstallPrompt = null;
      closeDialog(confirmButton.closest('[data-pwa-install-dialog]'));
      installPrompt.prompt();
      installPrompt.userChoice.then(function(choice) {
        if (choice.outcome === 'accepted') {
          hideWidgets();
        } else {
          showInstructions(confirmWidget, confirmWidget.dataset.installDeclined);
        }
      });
      return;
    }

    var dialog = event.target.closest('[data-pwa-install-dialog]');
    if (dialog && event.target === dialog) closeDialog(dialog);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', showWidgets, { once: true });
  } else {
    showWidgets();
  }
})();
